import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		width: '35%',
		[theme.breakpoints.down("sm")]:{
			width: '80%'
		}
	},
	title: {
		padding: theme.spacing(5, 2, 1, 2),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	closeButton: {
		'&:hover': {
			backgroundColor: 'transparent',
			color: '#141414',
			transition: 'all 0.5s ease-in-out'
		}
	},
	actionButton: {
		padding: theme.spacing(2, 2, 2, 2),
		'&:hover': {
			backgroundColor: 'transparent',
		}
	},
	content: {
		flex: 1,
		padding: theme.spacing(2),
		overflow: 'auto'
	},
	dateContent: {
		padding: theme.spacing(2, 2, 3, 2),
	},
	footer: {
		padding: theme.spacing(2, 2, 3, 2),
	}
}));

export default useStyles;